import { Actions } from "./actions";

export const dispatchRefreshApiCallLocation = (data) => {
  return { type: Actions.REFRESH_API_CALL_LOCATION, data };
};

export const dispatchRefreshApiCallPermission = (data) => {
  return { type: Actions.REFRESH_API_CALL_PERMISSION, data };
};

export const dispatchRefreshApiCallUser = (data) => {
  return { type: Actions.REFRESH_API_CALL_USER, data };
};

export const dispatchRefreshApiCallVendor = (data) => {
  return { type: Actions.REFRESH_API_CALL_VENDOR, data };
};

export const dispatchLocationsList = (data) => {
  return { type: Actions.LOCATIONS_LIST, data };
};

export const dispatchPermissionList = (data) => {
  return { type: Actions.PERMISSION_LIST, data };
};

export const dispatchUserListData = (data) => {
  return { type: Actions.USERLIST_DATA, data };
};

export const dispatchVendorListData = (data) => {
  return { type: Actions.VENDOR_LIST_DATA, data };
};
